<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="confirmModel" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="confirmModel = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    
  <insertForm :formSchema="formSchema" v-on:emitCloseModal="close"></insertForm>

    <v-card-title>
      <h2>User List</h2>
      <v-spacer></v-spacer>
      <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      :pagination.sync="pagination"
      :total-items="totalItems"
      :loading="loading"
      class="elevation-4"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-left">{{ props.item.email }}</td>
        <td class="text-xs-left">{{ props.item.role_name }}</td>
        <td class="text-xs-left">					
				<span v-if="props.item.is_active" class="active">Yes</span>						
				<span v-else class="in-active">No</span>						
				</td> 

        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0" v-if="userRole.updateButton" @click="editItem(props.index, props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" v-if="userRole.deleteButton" @click="deleteItem(props.index, props.item.id)"
          v-show="props.item.role_name.toLowerCase() !== 'admin'">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
        </td>
      </template>

      <template slot="no-data">
        <v-btn color="primary" @click="getDataFromApi()">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
let commonService = require("../../services/common.service");

import insertForm from "./insertForm.vue";
export default {
  components: {
    insertForm
  },

  data: () => ({
    dialog: false,
    totalItems: 0,
    loading: true,
    pagination: {
      sortBy: "id",
      descending: true
    },
    search: "",

    headers: [
      {
        text: "Name",
        align: "left",
        sortable: false,
        value: "name"
      },
      {
        text: "Email",
        align: "left",
        value: "email"
      },
      {
        text: "User Role",
        align: "left",
        value: "role_name"
      },
      {
        text: "Active",
        align: "left",
        value: "is_active"
      },
      {
        text: "Action",
        align: "center",
        value: ""
      }
    ],

    items: [],

    delete_id: "",
    row_index: "",
    confirmModel: false,

    SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },

    formSchema: {
      id: "",
      name: "",
      code: "",
      address: "",
      is_active: ""
    },

    queryData: {
      sortBy: "id",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      search_val: ""
    }
  }),

  computed: {
    userRole() {
      return this.$store.getters.get_USER_ROLE_DATA;
    }
  },

  mounted() {
    this.loadData();
    this.SnackbarVal.message = "Data loading!";
    this.SnackbarVal.snackbar = true;  
  },

  methods: {
    loadData(pagination) {
      commonService.getAllData("user").then(res => {
        this.items = res;
        this.loading = false;
      });
    },

    addNewUser(){
      //this.$store.commit('SET_COMMON_DATA');
      this.$router.push("/user/add-new-user");
    },

    editItem(index, item) {
      this.row_index = index;
      this.formSchema = { ...item }; 
      window.scrollTo({
        top: 0,
        left: 100,
        behavior: "smooth"
      });
    }, 

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.confirmModel = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "user").then(res => {
        if(res.status == 1)
        {
          this.items.splice(row_index, 1);
          this.close(res);
        }        
        this.confirmModel = false;
      });
    },


     close(res) {
     
      if (res.status == 1) {
        if (res.action == "add") {
          this.items.unshift({ ...res.data });
        }
        if (res.action == "edit") {
          this.$set(this.items, this.row_index, { ...res.data });
          this.row_index = "";
        }
        window.scrollTo({
          left: 0,
          top:
            document.body.scrollHeight || document.documentElement.scrollHeight,
            behavior: "smooth"
        });

        this.SnackbarVal.color = "success";
      }            
      else 
      {      
        this.SnackbarVal.color = "error";
      }      
      this.SnackbarVal.message = res.message;
      this.SnackbarVal.snackbar = true;
      console.log(this.items)
    }

  }
};
</script>



// WEBPACK FOOTER //
// src/components/user/users_table.vue